var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewNewProfileInfo extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.address = '';
        /** @override */ this.date_of_birth = '';
        /** @override */ this.departmentId = 0;
        /** @override */ this.email = '';
        /** @override */ this.firstname = '';
        /** @override */ this.gender = '';
        /** @override */ this.lastname = '';
        /** @override */ this.municipality = '';
        /** @override */ this.netsCallbackUrl = '';
        /** @override */ this.phone_number = '';
        /** @override */ this.postal_code = '';
    }
}
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "address", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewNewProfileInfo.prototype, "approve_storage", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewNewProfileInfo.prototype, "approve_tos", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "date_of_birth", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewNewProfileInfo.prototype, "departmentId", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "email", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "firstname", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "gender", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "lastname", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "municipality", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "netsCallbackUrl", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "phone_number", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewNewProfileInfo.prototype, "postal_code", void 0);
